import script from "./Top.vue?vue&type=script&lang=ts&setup=true"
export * from "./Top.vue?vue&type=script&lang=ts&setup=true"

import "./Top.vue?vue&type=style&index=0&id=1d0a33b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d0a33b6"]])

export default __exports__